import { render, staticRenderFns } from "./PhotoManage.vue?vue&type=template&id=bc46b002&scoped=true"
import script from "./PhotoManage.vue?vue&type=script&lang=js"
export * from "./PhotoManage.vue?vue&type=script&lang=js"
import style0 from "./PhotoManage.vue?vue&type=style&index=0&id=bc46b002&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc46b002",
  null
  
)

export default component.exports